import { render } from "./ToolDetailModal.vue?vue&type=template&id=61e2530a"
import script from "./ToolDetailModal.vue?vue&type=script&lang=js"
export * from "./ToolDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__